import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent {
  @Input() isOpen: boolean = false;
  @Input() message = '';
  @Output() isOpenChange = new EventEmitter<boolean>();
  constructor() { }

  close() {
    this.isOpen = false;
    this.isOpenChange.emit(false);
  }


}
